import { useState } from 'react';
import { COURSES, LECTURERS, CLASSROOMS } from '../data/mockData';
import { getSimulatedReply } from '../data/aiCannedReplies';

const COMPLIANCE = [
  { l: 'Academic planning controls documented (EduTrust)', done: true },
  { l: 'STB licence records verified for all guide trainers', done: true },
  { l: 'Classroom capacity and safety records current', done: true },
  { l: 'AI lab equipment insurance & software licences valid', done: true },
  { l: 'Approval workflow evidence for all plans', done: true },
  { l: 'Audit trail complete — AY2026 S1 to date', done: true },
  { l: 'Social Media Studio usage log maintained', done: true },
  { l: 'EduTrust deployment report submitted to authority', done: false },
];

export default function ReportsPage() {
  const [insight, setInsight] = useState(null);
  const [loading, setLoading] = useState(false);

  const runInsight = () => {
    setLoading(true);
    setInsight('generating');
    setTimeout(() => {
      setInsight(getSimulatedReply('optimise capacity risks growth opportunities'));
      setLoading(false);
    }, 1000);
  };

  const avgUtil = Math.round(CLASSROOMS.reduce((a, r) => a + r.util, 0) / CLASSROOMS.length);

  return (
    <div>
      <div className="sh-ey">REPORTS &amp; ANALYTICS · AY2026 SEM 1</div>
      <div className="sh-ti">Deployment Analytics</div>
      <div className="sh-de">AI-generated insights on workload, utilisation, enrolment, and compliance. Export PDF and Excel for EduTrust audit and STB reporting.</div>
      <div style={{ display: 'flex', gap: '.75rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <button className="btn btn-ai" onClick={runInsight}><i className="fa-solid fa-robot" /> AI Insights</button>
        <button className="btn btn-primary"><i className="fa-solid fa-file-pdf" /> Export PDF</button>
        <button className="btn btn-outline"><i className="fa-solid fa-file-excel" /> Export Excel</button>
      </div>
      {insight && (
        <div className="ai-result-card" style={{ marginBottom: '1.5rem', background: 'linear-gradient(135deg,#0F172A,#0F1F4A)' }}>
          <div className="ai-result-title"><i className="fa-solid fa-robot" /> AI Analytics Insight</div>
          <div className="ai-result-body">
            {loading
              ? <div className="ai-typing" style={{ padding: 0 }}><span /><span /><span /></div>
              : insight.split('\n').map((line, i) => (
                  <span key={i}>{line.split(/\*\*(.*?)\*\*/g).map((c, j) => (j % 2 === 1 ? <strong key={j}>{c}</strong> : c))}<br /></span>
                ))}
          </div>
        </div>
      )}
      <div className="g4" style={{ marginBottom: '1.5rem' }}>
        <div className="rm-big"><div className="rm-v">{COURSES.length}</div><div className="rm-l">Courses Deployed</div><div className="rm-tr" style={{ color: 'var(--green)' }}>↑ +6 AI &amp; Social Media new</div></div>
        <div className="rm-big"><div className="rm-v">{LECTURERS.length}</div><div className="rm-l">Active Lecturers</div><div className="rm-tr" style={{ color: 'var(--slate)' }}>Stable — 3 STB licensed</div></div>
        <div className="rm-big"><div className="rm-v">{avgUtil}%</div><div className="rm-l">Avg Room Utilisation</div><div className="rm-tr" style={{ color: 'var(--green)' }}>↑ Target exceeded</div></div>
        <div className="rm-big"><div className="rm-v">96%</div><div className="rm-l">Plan Accuracy</div><div className="rm-tr" style={{ color: 'var(--sea)' }}>EduTrust target: 95%</div></div>
      </div>
      <div className="g2" style={{ marginBottom: '1.5rem', alignItems: 'start' }}>
        <div className="card">
          <div className="ct">Lecturer Workload Report</div>
          <table className="tbl">
            <thead><tr><th>Lecturer</th><th>Hours</th><th>Load</th><th>Status</th></tr></thead>
            <tbody>
              {LECTURERS.map((l) => (
                <tr key={l.id}>
                  <td><div style={{ display: 'flex', alignItems: 'center', gap: '.55rem' }}><div style={{ width: 26, height: 26, borderRadius: 6, background: l.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.65rem', fontWeight: 700, color: 'var(--surface)', fontFamily: 'var(--font-mono)' }}>{l.ini}</div><span style={{ fontWeight: 600 }}>{l.name.split(' ').slice(-2).join(' ')}</span></div></td>
                  <td><span style={{ fontFamily: 'var(--font-mono)', fontSize: '.8rem', fontWeight: 600 }}>{l.load}h</span></td>
                  <td style={{ width: 100 }}><div className="pt-track"><div className={`pt-fill ${l.load >= l.max ? 'pf-coral' : 'pf-sea'}`} style={{ width: `${(l.load / l.max * 100).toFixed(0)}%` }} /></div></td>
                  <td><span className={`pill ${l.load >= l.max ? 'p-conf' : l.load >= l.max * 0.85 ? 'p-lock' : 'p-ok'}`}>{l.load >= l.max ? 'At Limit' : l.load >= l.max * 0.85 ? 'Near Limit' : 'Available'}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="card">
          <div className="ct">Room Utilisation</div>
          <table className="tbl">
            <thead><tr><th>Room</th><th>Type</th><th>Cap.</th><th>Util.</th></tr></thead>
            <tbody>
              {CLASSROOMS.map((r) => (
                <tr key={r.id}>
                  <td><span style={{ fontFamily: 'var(--font-mono)', fontSize: '.82rem', fontWeight: 700, color: 'var(--ocean)' }}>{r.id}</span></td>
                  <td style={{ fontSize: 'var(--text-sm)' }}>{r.type}</td>
                  <td style={{ fontFamily: 'var(--font-mono)', fontSize: '.82rem' }}>{r.cap}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '.55rem' }}>
                      <div className="pt-track" style={{ flex: 1, height: 5 }}><div className={`pt-fill ${r.util >= 90 ? 'pf-coral' : r.util >= 75 ? 'pf-gold' : 'pf-sea'}`} style={{ width: `${r.util}%` }} /></div>
                      <span style={{ fontFamily: 'var(--font-mono)', fontSize: '.75rem', fontWeight: 700, color: r.util >= 85 ? 'var(--red)' : r.util >= 75 ? 'var(--gold)' : 'var(--sea)', whiteSpace: 'nowrap' }}>{r.util}%</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="card">
        <div className="ct">EduTrust &amp; STB Compliance</div>
        <div className="g2">
          {COMPLIANCE.map((c) => (
            <div key={c.l} style={{ display: 'flex', alignItems: 'center', gap: '.75rem', padding: '.68rem .85rem', background: c.done ? 'var(--green-dim)' : '#FFFBEB', borderRadius: 7, border: `1px solid ${c.done ? '#A7F3D0' : '#FDE68A'}` }}>
              <i className={`fa-solid ${c.done ? 'fa-circle-check' : 'fa-clock'}`} style={{ color: c.done ? 'var(--green)' : 'var(--gold-bg)', fontSize: '1rem', flexShrink: 0 }} />
              <span style={{ fontSize: 'var(--text-sm)', fontWeight: 500, color: c.done ? 'var(--green)' : 'var(--gold)' }}>{c.l}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
